import React, { ComponentProps } from 'react'

import { styled } from 'nativewind'

import { colors } from '../tailwind'
import { Text } from '../typography'

const TagContainerText = styled(
  Text,
  'py-1 px-2 leading-4 self-center text-center text-[10px]',
  {
    variants: {
      rounded: {
        full: 'rounded-full',
        small: 'rounded',
      },
    },
    defaultProps: {
      rounded: 'small',
    },
  }
)
type TagFrameProps = ComponentProps<typeof TagContainerText>

const Tag: React.FC<TagFrameProps> = ({ ...props }) => {
  return (
    <TagContainerText
      {...props}
      style={{
        backgroundColor: colors?.decorative?.terraCotta,
        color: colors?.neutral.white100,
        marginTop: 3,
      }}
    >
      {props.children}
    </TagContainerText>
  )
}

export default Tag
